module.exports = __webpack_public_path__ + "img/quote.cdf83c2f.svg";